module.exports = __webpack_public_path__ + "static/media/waterloo.5e779926.jpg";